<template>
<div id="container" class="libero_alarm active">
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <div class="fullscreen_background z1 active">
        <img src="/static/assets/libero_alarm/Hintergrund_2860.jpg" />
    </div>

    <div class="z3 active timer">
      <img src="/static/assets/libero_alarm/libero_alarm_timer_ohne.png" />
      <img src="/static/assets/libero_alarm/Zeiger_Timer.png" id="timerzeiger"  v-bind:style="{ transform: 'rotate(' + minutes + 'deg)' }" />
    </div>
    <div class="z3 active minuten">
      <div class="z3 active minuten_01 pointer" v-on:click="maxzeitPlus"><img src="/static/assets/libero_alarm/libero_alarm_plus.png"></div>
      <div class="z3 active minuten_02 pointer" v-on:click="maxzeitMinus"><img src="/static/assets/libero_alarm/libero_alarm_minus.png"></div>
    </div>
    <div class="z5 active aus pointer" v-on:click="resetLiberoAlarm"><img src="/static/assets/libero_alarm/libero_alarm_aus.png"></div>
    <div class="z5 active ok pointer" v-on:click="liberoAlarmOK"><img src="/static/assets/libero_alarm/libero_alarm_ok.png"></div>
    <div class="liberoAlarmZeit z10">
      <p>{{maxzeitTimeString}}</p>
    </div>
    <div class="z6 active libero"><img src="/static/assets/libero_alarm/libero_alarmLibero.png"></div>

    <div class="z14 active text"><img src="/static/assets/libero_alarm/libero_alarm_headline.png">
    <div class="fliesstext active">
      <p>Wie lange darf Ihr Kind auf der Hugidubies-Website bleiben? Legen Sie den Zeitraum gemeinsam mit Ihrem Kind fest und stellen Sie die Minutenanzahl ein.</p>
      <p>Der Libero-Alarm zeigt Ihrem Kind dann das Ende der gemeinsam vereinbarten Verweildauer an. 
</p>
    </div>
    </div>
    <div class="resetmessagebox z50 active" v-if="showresetwindow">
      <div class="fullbg_dark z49 active"></div>
      <div class="messagebox z50 active">
        <router-link to="/" tag="img" class="active pointer" src="/static/assets/alle/Libero_alarm_ende.png" />
      </div>
    </div>
    <div class="resetmessagebox z50 active" v-if="showstartwindow">
      <div class="fullbg_dark z49 active"></div>
      <div class="messagebox z50 active">
        <router-link to="/" tag="img" class="active pointer" src="/static/assets/libero_alarm/Libero_alarm_start.png" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
import { bus } from '@/main.js'
window.$ = window.jQuery = require('jquery')

export default {
  name: 'Liberoalarm',
  data () {
    const stunde = 3600000
    var x = window.maxzeit
    if (x > 3600000) x = x - 3600000
    x = (x / 100) / 360 / 0.27777777777778    
    return {
      who: 'Liberoalarm',
      maxzeitTimeString: '',
      showresetwindow: false,
      showstartwindow: false,
      minutes: x
    }
  },
  computed: {
    getTimerwert () {
      return this.timerwert
    }
  },
  watch: {
    showresetwindow: function (oldval, newval) {
      console.log('showresetwindow: ', oldval, newval)
    },
    showstartwindow: function (oldval, newval) {
      console.log('showstartwindow: ', oldval, newval)
    },
    minutes: function (oldval, newval) {
      console.log('minutes: ', newval)
    }
  },
  methods: {
    setTimerMinutes () {
      const stunde = 3600000
      var x = window.maxzeit
      if (x > 3600000) x = x - 3600000
      this.minutes = (x / 100) / 360 / 0.27777777777778
      return this.minutes 
    },
    toggleBodyClass (addRemoveClass, className) {
      const el = document.body

      if (addRemoveClass === 'addClass') {
        el.classList.add(className)
      } else {
        el.classList.remove(className)
      }
    },
    getMaxzeitTimeString () {
      /*
      function pad (number) {
        if (number < 10) {
          return '0' + number
        } else {
          return number
        }
      }
      */
      function timeFormatter (d) {
        // return pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes())  + ':' + pad(d.getUTCSeconds())
        var h = d.getUTCHours()
        var s = ''
        if (h > 1) {
          s = h + ' Stunden'
        } else {
          if (h === 1) {
            s = h + ' Stunde'
          }
        }
        var m = d.getUTCMinutes()
        if (m > 0) {
          if (h > 0) s = s + ', '
          if (m === 1) {
            s = s + '1 Minute'
          } else {
            if (m > 1) {
              s = s + m + ' Minuten'
            }
          }
        }
        return s
      }

      if (window.maxzeit === null) {
        window.maxzeit = 60000
      }
      var d = new Date(parseInt(window.maxzeit))
      window.maxzeitTimeString = timeFormatter(d)
      this.maxzeitTimeString = window.maxzeitTimeString
      console.log('getTime', d.getTime())
      console.log('getMaxzeitTimeString', this.maxzeitTimeString)
      return this.maxzeitTimeString
    },
    resetLiberoAlarm () {
      console.log('liberoAlarmAus gedrückt...')
      window.localStorage.removeItem('verweilt')
      window.maxzeit = 60000
      window.localStorage.clear()
      console.log('localStorage.clear() ausgeführt...')
      window.noAlarm = true
      this.showresetwindow = true
      this.setTimerMinutes()
    },
    maxzeitPlus () {
      console.log('increase maxzeit')
      var t = parseInt(window.maxzeit)
      if (isNaN(t)) {
        t = 600000 // 10 minuten default
      } else {
        // + 1 minute
        t = t + 60000
        // + 10 minuten
        // t = t + 300000
      }
      window.maxzeit = t
      window.localStorage.setItem('maxzeit', t)
      this.setTimerMinutes()
      console.log('ausgeführt...', this.getMaxzeitTimeString())
    },
    maxzeitMinus () {
      console.log('increase maxzeit')
      var t = parseInt(window.maxzeit)
      // 60000 = 1 minute
      t = t - 60000
      // t = t - 300000
      if (t < 0) t = 60000
      window.maxzeit = t
      window.localStorage.setItem('maxzeit', t)
      this.setTimerMinutes()
      console.log('ausgeführt...', this.getMaxzeitTimeString())
    },
    liberoAlarmOK () {
      console.log('liberoAlarmOk gedrückt')
      window.localStorage.setItem('verweilt', 0) // reset counter
      window.noAlarm = false
      this.showstartwindow = true
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright
  },
  mounted () {
    this.$ga.page(this.$router)
    console.log('mounted called')
    this.toggleBodyClass('addClass', 'liberoAlarmSeite')
    window.liberoAlarmObj = this
    window.maxzeit = window.localStorage.getItem('maxzeit')
    if (window.maxzeit === '') {
      window.maxzeit = 600000 // 10 minuten
      window.maxzeit = window.localStorage.setItem('maxzeit', window.maxzeit)
    }
    // uhr initialisieren
    this.getMaxzeitTimeString()
    bus.$on('liberoalarm_aus',this.resetLiberoAlarm)
  },
  destroyed () {
    this.toggleBodyClass('removeClass', 'liberoAlarmSeite')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}
/* ELTERNINFO */
.z6.active.libero {
    /*bottom: -4px;*/
    bottom: -94px;
    left: 25%;
}
.libero {animation: libero_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; margin-bottom: -270px;}
@keyframes libero_erscheint {
    0% {margin-bottom: -270px; transform: scale(0.5); opacity:0;}
    75% {transform: scale(1.1); opacity:1;}
    100% {margin-bottom: 0px; transform: scale(1); opacity:1;}
}
.z3.active.timer {
    top: 17%;
    right: 24.5%;
}
.libero_alarm .text {
    top: 28%;
    left: 16.5%;
}
.z3.active.minuten {
    top: 65%;
    right: 44%;
}
.z3.active.minuten_02 {
    margin-top: 75px;
}
.z5.active.aus {
    bottom: 10%;
    right: 37%;
}
.z5.active.ok {
    bottom: 10%;
    right: 30%;
}

.libero_alarm #menulayer {
    top: 3.5%;
    right: 22%;
}
.libero_alarm div {position:absolute; }
.libero_alarm div{display:none;}
.libero_alarm .active{display:block !important;}
.libero_alarm #libero_alarm{position: absolute; width: 1920px; height: 1080px;}

.logo, .menu, .stoppuhr, .liberoAlarmZeit { display:inherit !important;}
area, .lautsprecher, .restart, .karte_bottom_01, .karte_bottom_02, .karte_bottom_03, .minuten_01, .minuten_02, .memo_01, memo_02, .malen_01, .malen_02 {
    cursor: pointer;
}
.fliesstext {
    top: 140%;
    left: 0;
    width: 540px;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
    position: absolute;
    height: 450px;
}

.liberoAlarmZeit {
  position: absolute;
  top: 720px;
  left: 1200px;
  font-family: 'Open sans';
  font-size: 35px;
}

.fullbg_dark {
  position: fixed !important;
  display: block;
  top: 0;
  left: -25%;
  width: 150%;
  height: 100%;
  opacity: 0.8;
  background-color: #000000;  
}
img#timerzeiger {
    position: absolute;
    top: 86px;
    left: 228px;
    transform: scale(0.95); 
    transform-origin: bottom center;
}

.messagebox { position: fixed !important; top: 25%; left: calc(50% - 209px); display: block;}
</style>



// WEBPACK FOOTER //
// src/components/Liberoalarm.vue